var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"organization"}},[(!_vm.pageReady)?_c('BLoading',{attrs:{"active":!_vm.pageReady}}):_c('WtTile',{attrs:{"vertical":""}},[_c('MobilePreventativeChallenge')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }